import { useEffect, useRef, useState } from "react";
import { createContext, useContext } from "react";
import Cookie from "universal-cookie";
import { TokenRefresh } from "../Services/lib/auth";
import { logOutControl, parseJwt, tokenRefreshControl } from "./functions";
import { GetBrand } from "../Services/lib/brand";
import { build_config } from "../hooks/use-api";
import ls from "local-storage";

const UserContext = createContext();

function UserProvider({ children }) {
	const localLocale = ls.get("locale");
	const [isLogged, setLogged] = useState(false);
	const [tokens, setTokens] = useState({
		access_token: null,
		id_token: null,
		id: null,
		group: null,
		username: null,
	});
	const [isloading, setLoading] = useState(true);
	const [username, setUsername] = useState(null);
	const [brand, setbrand] = useState();
	const [locale, setLocal] = useState(localLocale || "en");

	const interval = useRef(null);

	const logOut = () => {
		logOutControl(Cookie, interval, setTokens, setLogged);
	};

	useEffect(() => {
		ls.set("locale", locale);
	}, [locale]);

	useEffect(() => {
		const cookies = new Cookie();
		const refreshToken = cookies.get("refresh_token");
		const username = cookies.get("username");
		setUsername(username);
		if (refreshToken) {
			setLoading(true);
			tokenRefreshControl(
				refreshToken,
				username,
				interval,
				setTokens,
				setLogged
			);
			TokenRefresh({
				body: {
					refreshToken,
					username,
				},
			})
				.then((data) => {
					console.log("======>", data);
					const dec = parseJwt(data.AccessToken);
					if (data.x_brand) {
						if (dec["cognito:groups"][0] !== "admin") {
							setbrand({ _id: data.x_brand });
						}
					}
					setTokens({
						access_token: data.AccessToken,
						id_token: data.IdToken,
						id: dec.sub,
						group: dec["cognito:groups"][0],
						username: dec.username,
					});
					setLogged(true);
					setLoading(false);
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => {
					setLoading(false);
				});
		} else {
			setLoading(false);
		}
		return () => {
			clearInterval(interval.current);
		};
	}, []);

	useEffect(() => {}, [locale]);

	const getBrand_ = async (access_token, brand_) => {
		const config = build_config({ access_token, brand: brand_ });
		const res = await GetBrand({ config });
		if (res) {
			setbrand(res);
		}
	};

	useEffect(() => {
		if (brand && tokens.access_token && !brand.domain) {
			getBrand_(tokens.access_token, brand);
		}
	}, [brand, tokens]);

	return (
		<UserContext.Provider
			value={{
				brand,
				isLogged,
				tokens,
				interval,
				username,
				isloading,
				locale,
				setLocal,
				setbrand,
				logOut,
				setTokens,
				setLogged,
				setUsername,
				setLoading,
			}}
		>
			{children}
		</UserContext.Provider>
	);
}

function useUser() {
	const context = useContext(UserContext);
	if (context === undefined) {
		throw new Error("useUser must be used within a UserProvider");
	}
	return context;
}
export { useUser, UserProvider };
